<template>
  <div>
    <h3 style="margin-top: 300px">Editing Interface View</h3>
    <div class="row">
      <div class="col-xs-12">
      </div>
  </div>
  </div>
</template>


<script>
export default {
  name: 'Editing Interface'
}
</script>


<style scoped>
h3 {
  text-align: center;
}
</style>
